// src/store/modules/demoMode.js

export const DEMO_STATUS = Object.freeze({
  OFF: 'off',
  ACTIVATING: 'activating',
  READY: 'ready',
  FAILED: 'failed',
})

export default {
  namespaced: true,
  state: () => ({
    status: DEMO_STATUS.OFF,
    generation: 0,
    coveredCount: 0,
    persistFailed: false,
    remoteExitIgnored: false,
  }),
  mutations: {
    SET_STATUS(state, status) {
      state.status = status
    },
    NEXT_GENERATION(state) {
      state.generation += 1
    },
    SET_COVERED_COUNT(state, count) {
      state.coveredCount = count
    },
    SET_PERSIST_FAILED(state, failed) {
      state.persistFailed = Boolean(failed)
    },
    SET_REMOTE_EXIT_IGNORED(state, ignored) {
      state.remoteExitIgnored = Boolean(ignored)
    },
  },
  getters: {
    status: (state) => state.status,
    generation: (state) => state.generation,
    isDemoMode: (state) => state.status !== DEMO_STATUS.OFF,
    isReady: (state) => state.status === DEMO_STATUS.READY,
    sensitiveEgressBlocked: (state) => state.status !== DEMO_STATUS.OFF,
    coveredCount: (state) => state.coveredCount,
    persistFailed: (state) => state.persistFailed,
    remoteExitIgnored: (state) => state.remoteExitIgnored,
  },
}
